<template>
  <div class="overlayWrap">
    <div class="operateSwitch" v-if="UserChannelPermission != 5">
      <!-- CC开关 -->
      <div class="switchItem">
        <span class="title" :class="{'DisabledTitle': CloneDisabled.Singular || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton}">CC</span>
        <span
          v-show="switchLoading.cc"
          class="pushingIcon"
        >
          <i class="el-icon-loading" />
        </span>
        <el-switch :disabled="!transcriberStatus.transcriberShow||!transcriberStatus.isOpenFeature || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton" v-show="!switchLoading.cc" v-model="CCOnFlag" @change="changeCC" active-color="#13ce66" inactive-color="#666666"></el-switch>
      </div>
      <!-- logo开关 -->
      <div class="switchItem">
        <span class="title" :class="{'DisabledTitle': CloneDisabled.Singular || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton}">{{ $t('lang.logo') }}</span>
        <span
          v-show="switchLoading.logo"
          class="pushingIcon"
        >
          <i class="el-icon-loading" />
        </span>
        <el-switch :title="ShortcutText.Logo" :disabled="CloneDisabled.Logo || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton" v-show="!switchLoading.logo" v-model="nativeInfo.logoOnFlag" active-color="#13ce66" @change="setLogo" inactive-color="#666666"></el-switch>
      </div>
      <!-- 滚动字幕开关 -->
      <div class="switchItem">
        <span class="title" :class="{'DisabledTitle': CloneDisabled.Singular || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton}">{{ $t('lang.Crawl') }}</span>
        <span
          v-show="switchLoading.crawl"
          class="pushingIcon"
        >
          <i class="el-icon-loading" />
        </span>
        <el-switch :title="ShortcutText.Crawl" :disabled="CloneDisabled.Crawl || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton" v-show="!switchLoading.crawl" v-model="nativeInfo.CrawlOnFlag" active-color="#13ce66" @change="setCrawl" inactive-color="#666666"></el-switch>
      </div>
      <!-- 外部图文开关 -->
      <div class="switchItem">
        <span class="title" :class="{'DisabledTitle': CloneDisabled.Singular || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton}">{{ $t('lang.Singular') }}</span>
        <span
          v-show="switchLoading.singular"
          class="pushingIcon"
        >
          <i class="el-icon-loading" />
        </span>
        <el-switch :disabled="CloneDisabled.Singular || CloneDisabled.OverlaySwitch||CloneDisabled.disableButton" v-show="!switchLoading.singular" v-model="SingularOnFlag" active-color="#13ce66" @change="setSingular" inactive-color="#666666"></el-switch>
      </div>
    </div>
    <!-- 操作切换 -->
    <div class="BottomOperation">
      <div class="RightClassify">
        <div v-for="(item,index) in ClassifyList" :key="index">
          <div :class="['SortChunk',{'PitchSortChunk': PitchClass == item.type},{'outputColor': item.showColor} ]" v-if="item.switch" @click="changeRightType(item)">
            <div>
               <i :class="['iconfont',item.icon]"></i>
              <p>{{$t(item.name)}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="LeftContentList">
        <!-- 外部图文 -->
        <ExtGfx v-if="PitchClass == 'singular' && singularLoaded" :SingularMessage="SingularMessage" ref="singular"/>
        <!-- 本地图文 -->
        <Native :fixedDevice="fixedDevice" :nativeInfo="nativeInfo" v-if="PitchClass == 'native' && fixedDevice"/>
        <!-- scte设置 -->
        <Scte ref="ScteInfo" :fixedDevice="fixedDevice" v-if="PitchClass == 'scte' && fixedDevice"/>
        <!-- LBand图文 -->
        <l-band-list v-if="PitchClass == 'lBand'"></l-band-list>
        <!-- 输出监控 -->
        <Buffer :fixedDevice="fixedDevice" v-if="PitchClass == 'Buffer' && fixedDevice"/>
        <!-- 输出 -->
        <aux-output v-if="PitchClass=='AuxOutput'"></aux-output>
      </div>
    </div>
    <!-- transcriber手动模式切换弹框  -->
    <auto-sensing-dialog v-if="dialogMessage.show" :dialogMessage='dialogMessage' @updateAutoStatus='updateAutoStatus'></auto-sensing-dialog>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'
import ExtGfx from './ExtGfx.vue'
import Native from './native.vue'
import Scte from './scte.vue'
import AutoSensingDialog from '../common/AutoSensingDialog.vue'
import LBandList from './LBand/LBandList.vue'
import Buffer from './Buffer.vue'
import { mapActions, mapState } from 'vuex'
import { ShortcutText } from '@/assets/js/common/ParamConfig.js'
import AuxOutput from './AuxOutput.vue'
export default {
  props: {
    transcriberStatus: {
      type: Object
    }
  },
  data () {
    return {
      // R改变信息
      fixedDevice: null,
      // CC按钮开关
      CCOnFlag: false,
      // Singular开关
      SingularOnFlag: false,
      // Singular信息
      SingularMessage: {},
      // Singular Url
      SingularpgmUlr: '',
      singularLoaded: false,
      // 开关loading
      switchLoading: {
        cc: false,
        logo: false,
        crawl: false,
        singular: false
      },
      // 本地图文 logo 和crawl开关
      nativeInfo: {
        logoOnFlag: false,
        CrawlOnFlag: false
      },
      // crawl信息
      previewObj: {
        syncSwitch: false,
        CrawlLoading: true
      },
      // 右边类别列表
      ClassifyList: [
        {
          icon: 'icon-SCTE1',
          name: 'lang.SCTE',
          type: 'scte',
          switch: true,
          showColor: false
        },
        {
          icon: 'icon-Overlay',
          name: 'lang.NativeGFX',
          type: 'native',
          switch: true,
          showColor: false
        },
        {
          icon: 'icon-a-ExtGFX',
          name: 'lang.Singular',
          type: 'singular',
          switch: true,
          showColor: false
        },
        {
          icon: 'icon-L-band',
          name: 'lang.LBand',
          type: 'lBand',
          switch: false,
          showColor: false
        },
        {
          icon: 'icon-buffer',
          name: 'lang.Buffer',
          type: 'Buffer',
          switch: false,
          showColor: false
        },
        {
          icon: 'icon-a-auxoutput',
          name: 'lang.AuxOutput',
          type: 'AuxOutput',
          switch: true,
          showColor: false
        }
      ],
      // 当前的类别
      PitchClass: 'scte',
      // 是否改为手动模式弹框信息
      dialogMessage: {
        show: false
      },
      // 快捷键配置
      ShortcutText: ShortcutText,
      programId: ''

    }
  },
  components: {
    ExtGfx,
    Native,
    Scte,
    AutoSensingDialog,
    LBandList,
    Buffer,
    AuxOutput
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled,
      listFeatures: (state) => state.playout.listFeatures,
      // 用户权限
      UserChannelPermission: (state) => state.playout.UserChannelPermission
    })
  },
  watch: {
    // 行为同步
    '$store.state.BehaviorChange' (data) {
      console.log('right-bottom')
      if (data.action == 'LogoListChange') {
        this.inquireLogo()
      } else if (data.action == 'CrawlListChange') {
        this.inquireCrawl()
      } else if (data.action == 'programAuxTurnOn') {
        this.changeAuxColor(true)
      } else if (data.action == 'programAuxTurnOff') {
        this.changeAuxColor(false)
      }
    },
    listFeatures: {
      handler (val) {
        if (val.includes('L-Band')) {
          this.ClassifyList[3].switch = true
        } else {
          this.ClassifyList[3].switch = false
        }
        if (val.includes('OutputBuffer')) {
          this.ClassifyList[4].switch = true
        } else {
          this.ClassifyList[4].switch = false
        }
        if (val.includes('Auxiliary Live Output')) {
          this.ClassifyList[5].switch = true
        } else {
          this.ClassifyList[5].switch = false
        }
      },
      immediate: true
    },
    // 监听cc开关状态
    'transcriberStatus.setOn': {
      handler (val) {
        this.CCOnFlag = val
      },
      immediate: true
    },
    // 用户权限
    UserChannelPermission: {
      handler (data) {
        if (data == 5) {
          this.ClassifyList = [
            {
              icon: 'icon-SCTE1',
              name: 'lang.SCTE',
              type: 'scte',
              switch: true
            }
          ]
        }
      },
      immediate: true
    }
  },
  created () {
    this.CCOnFlag = this.transcriberStatus.setOn
    this.programId = this.$BehaviorSyns.getProgramId()
    this.outputInfo()
  },
  mounted () {
    // 监听r改变
    Bus.$on('playOutVideoR', (item) => {
      this.fixedDevice = item
      this.getExtGfx()
      this.inquireLogo() // 查询logo设置信息
      this.inquireCrawl() // 查询功能信息
    })
    // 快捷键监听
    this.$on('LogoCrawlScteShortcut', (type) => {
      if (type == 'Logo') {
        this.nativeInfo.logoOnFlag = !this.nativeInfo.logoOnFlag
        this.setLogo()
      } else if (type == 'Crawl') {
        this.nativeInfo.CrawlOnFlag = !this.nativeInfo.CrawlOnFlag
        this.setCrawl()
      } else if (type == 'Scte') {
        this.$refs.ScteInfo.$emit('ScteShortcut')
      }
    })
  },
  methods: {
    ...mapActions('playout', ['getFeatureList']),
    // 右侧导航变化
    changeRightType (item) {
      this.PitchClass = item.type
      this.JudgeSingular()
    },
    // 判断singular变化
    JudgeSingular () {
      if (this.PitchClass == 'singular' && (!this.SingularMessage.singularStatus && this.SingularMessage.token)) {
        Bus.$emit('IsSelectSingular', { select: true })
      } else {
        Bus.$emit('IsSelectSingular', { select: false })
      }
    },
    // 修改aux颜色
    changeAuxColor (flag) {
      this.ClassifyList.forEach(item => {
        if (item.type == 'AuxOutput') {
          item.showColor = flag
        } else {
          item.showColor = false
        }
      })
    },
    // 查看是否正在output
    outputInfo () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/auxoutput/starting/info'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result
          if (result && result.status) {
            this.changeAuxColor(true)
            console.log(this.ClassifyList)
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 查询Crawl设置信息
    inquireCrawl () {
      this.axios
        .post(Outil.getUrl('/crawl/getCrawl'), {
          entityType: 0,
          entityId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result) {
              const CrawlOnFlag = res.data.result.setOn || res.data.result.secondarySetOn
              this.nativeInfo.CrawlOnFlag = !!CrawlOnFlag

              Bus.$emit('CrawlOnFlag', this.nativeInfo.CrawlOnFlag)
            } else {
              this.nativeInfo.CrawlOnFlag = false
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
            this.nativeInfo.CrawlOnFlag = false
          }
        }).catch(() => {})
    },
    // 查询logo设置信息
    inquireLogo () {
      this.axios.post(Outil.getUrl('/program/getProgram'), {
        programId: this.programId
      }).then((res) => {
        this.getDefaultLogo = true
        if (res.data.errorCode == '0x0') {
          const logoOnFlag = res.data.result.logoOn || res.data.result.secondaryLogoOn
          this.nativeInfo.logoOnFlag = !!logoOnFlag
        }
      }).catch(() => {})
    },
    // 设置logo
    async setLogo () {
      this.switchLoading.logo = true
      this.axios
        .post(Outil.getUrl('/program/updateProgramLogoValue'), {
          logoOn: this.nativeInfo.logoOnFlag ? 1 : 0,
          id: this.programId
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            this.inquireLogo()
          } else {
            this.nativeInfo.logoOnFlag = !this.nativeInfo.logoOnFlag
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.switchLoading.logo = false
        }).catch(() => {
          this.nativeInfo.logoOnFlag = !this.nativeInfo.logoOnFlag
          this.switchLoading.logo = false
        })
    },
    // 设置Crawl
    setCrawl () {
      const param = {
        entityType: 0,
        entityId: this.$BehaviorSyns.getProgramId(),
        setOn: this.nativeInfo.CrawlOnFlag ? 1 : 0
      }
      this.switchLoading.crawl = true
      this.axios
        .post(Outil.getUrl('/crawl/setCrawl'), param)
        .then((res) => {
          this.inquireCrawl()
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else {
            this.nativeInfo.CrawlOnFlag = !param.setOn
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.switchLoading.crawl = false
        }).catch(() => {
          this.nativeInfo.CrawlOnFlag = !param.setOn
          this.switchLoading.crawl = false
        })
    },
    // 设置Singularl
    async setSingular () {
      const singularStatus = this.SingularMessage.singularStatus
      if ((singularStatus == 1 && !this.SingularMessage.appUrl) || (singularStatus == 0 && !this.SingularMessage.token) || (singularStatus == 2 && !this.SingularMessage.flowicsToken)) {
        this.$message({
          message: this.$t('lang.TokenUrlEmpty'),
          type: 'warning'
        })
        this.SingularOnFlag = false
        return
      }
      this.switchLoading.singular = true
      if (singularStatus == 0 && !this.SingularpgmUlr) {
        try {
          await $.get(`https://app.singular.live/apiv1/control/${this.SingularMessage.token}/output`)
            .then((res) => {
              if (res) {
                this.SingularpgmUlr = res.outputUrl
              }
            })
        } catch (error) {
        }
      }
      const pgmUlr = singularStatus == 0 ? this.SingularpgmUlr : (singularStatus == 1 ? this.SingularMessage.appUrl : this.SingularMessage.vmUrl)
      const param = {
        pgmUlr: pgmUlr,
        programId: this.$BehaviorSyns.getProgramId(),
        setOn: this.SingularOnFlag ? 1 : 0
      }
      this.axios
        .post(Outil.getUrl('/singular/setSingular'), param)
        .then((res) => {
          this.getExtGfx()
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
          } else if (res.data.errorCode == '81003406') {
            this.SingularOnFlag = !param.setOn
            this.$message.info(this.$t('lang.CheckSingularToken'))
          } else {
            this.SingularOnFlag = !param.setOn
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.switchLoading.singular = false
        }).catch(() => {
          this.SingularOnFlag = !param.setOn
          this.switchLoading.singular = false
        })
    },
    // 获取ExtGfx信息
    getExtGfx () {
      this.axios
        .post(Outil.getUrl('/singular/getSingular'), {
          programId: this.$BehaviorSyns.getProgramId()
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result) {
              this.SingularOnFlag = !!res.data.result.setOn
              this.SingularMessage = res.data.result
              this.JudgeSingular()
            } else {
              this.SingularOnFlag = false
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
            this.SingularOnFlag = false
          }
          this.singularLoaded = true
        }).catch(() => {})
    },
    // CC开关切换
    changeCC (val) {
      this.axios
        .post(Outil.getUrl('/transcriber/setTranscriber'), {
          programId: this.$BehaviorSyns.getProgramId(),
          setOn: val
        })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            if (this.transcriberStatus.isAuto) {
              this.dialogMessage.show = true
            }
          } else {
            this.CCOnFlag = !val
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }).catch(() => {})
    },
    // 自动状态改为手动
    updateAutoStatus (val) {
      this.transcriberStatus.isAuto = val
    }
  },
  beforeDestroy () {
    Bus.$off('playOutVideoR')
  }
}
</script>

<style lang="less" scoped>
.overlayWrap {
  height: 100%;
  position: relative;
  .operateSwitch {
    // max-width: 432px;
    display: flex;
    align-items: center;
    padding: 0 0 10px 38px;
    border-bottom: 2px solid #252525;
    margin: 0px;
    justify-content: space-between;
    .el-icon-minus {
      transform: rotate(90deg);
      color: #666;
      font-weight: bold;
      margin-top: 10px;
    }
    .switchItem {
      // margin-right: 40px;
      padding-right: 20px;
      text-align: center;
      .title {
        display: block;
        margin-top: 1px;
      }
      .el-switch {
        display: block;
      }
      .DisabledTitle{
        color: #999;
        opacity: .6;
      }
      .pushingIcon {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        width: 40px;
        background: #33AB4F;
        border-radius: 10px;
        text-align: center;
        border: 1px solid #33AB4F;
        outline: none;
        vertical-align: middle;
        margin: 0!important;
      }
    }
  }
  .BottomOperation {
    height: calc(100% - 53px);
    display: flex;
    flex-direction: row-reverse;
    .RightClassify {
      width: 64px;
      background: #333333;
      padding-bottom: 20px;
      .SortChunk {
        width: 64px;
        height: 64px;
        background: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666666;
        i {
          font-size: 22px;
        }
        p {
          width: 52px;
          font-size: 12px;
          font-weight: 400;
          line-height: 12px;
          margin: 0;
          cursor: pointer;
        }
      }
      .PitchSortChunk {
        background: #444444;
        i {
          color: #cccccc;
        }
        p {
          color: #cccccc;
        }
      }
      .outputColor{
        color: #E56464;
      }
    }
    .LeftContentList {
      width: calc(100% - 80px);
      background: #444444;
      padding: 0 20px 0px 20px
    }
  }
  @media (max-width: 1680px) {
  .BottomOperation {
   height: 418px;
  }
}
}
</style>
